
import PosjecenostDokumenta from "./PosjecenostDokumenta";
import UkupnaPosjecenostDokumenta from "./UkupnaPosjecenostDokumenta";
import TopDokumenti from "./TopDesetDokumenata";
import { Row } from "antd";
import "./StatistikaDokumenataPage.css";
import Background from "../../components/Background4";

const StatistikaDokumenataPage = () => {
  return (
    <div>
      <Background />

      <div className="statdokumenatapage">
        <div className="statistika-dokumenata-frame">
          <div className="statdokumentapage-div">
            <Row>
              <PosjecenostDokumenta />
            </Row>
            <Row style={{ width: "100%" }}>
              <UkupnaPosjecenostDokumenta />
            </Row>
            <Row style={{ width: "100%" }}>
              <TopDokumenti />
            </Row>
          </div>
        </div>
      </div>
    </div>
  );
};

export default StatistikaDokumenataPage;
